import { Plugin } from 'prosemirror-state'

import { isMacintosh } from 'utils'

export const OpenLinkInNewTab = new Plugin({
  props: {
    handleDOMEvents: {
      mousedown: (view, event) => {
        if (!(event instanceof MouseEvent)) return false
        if (!(isMacintosh() ? event.metaKey : event.ctrlKey)) return false

        // resolve the inline node that was clicked on
        const pos = view.posAtDOM(event.target as Node, 0)
        const maybeNodeWithLink = view.state.doc.nodeAt(pos)
        if (!maybeNodeWithLink) return false

        const link = view.state.schema.marks.link.isInSet(maybeNodeWithLink.marks)
        if (!link) return false

        if (!event.target) return false
        if (!(event.target instanceof HTMLElement)) return false

        const contentEditableBefore = event.target.contentEditable
        event.target.contentEditable = 'false'
        setTimeout(() => {
          if (event.target instanceof HTMLElement) event.target.contentEditable = contentEditableBefore
          view.focus()
        }, 200) // don't judge me

        return true
      },
    },
  },
})
